export default __webpack_public_path__ + "static/media/transport_icon.0cf79fb1.svg";